import React, { useCallback, useMemo } from 'react';
import { PROJECT_STATUS } from '../../../utils/constants';
import { concatClassNames } from '../../../utils/utilities';

import classNames from './style.module.scss';

interface ProjectStatusButtonProps {
	isActive: boolean;
	status: string;
	onClick?: () => void;
}

const ProjectStatusButton: React.FC<ProjectStatusButtonProps> = (props) => {
	const className = useMemo((): string => {
		switch (props.status) {
			case PROJECT_STATUS.COMPLETED:
				return classNames.projectStatusCompleted;

			case PROJECT_STATUS.PENDING:
				return classNames.projectStatusPending;
			
			case PROJECT_STATUS.AWAITING_ACTIVATION:
				return classNames.projectStatusAwaiting;
			
			case PROJECT_STATUS.PUBLISHED_FOR_REVIEW:
				return classNames.projectStatusReview;

			case PROJECT_STATUS.PUBLISHED_FOR_INTERNAL_APPROVAL:
				return classNames.projectStatusPublished;
			
			case PROJECT_STATUS.PUBLISHED_FOR_EXTERNAL_REVIEW:
				return classNames.projectStatusExternalReview;

			case PROJECT_STATUS.PUBLISHED_FOR_EXTERNAL_APPROVAL:
				return classNames.projectStatusExternalApproval;
			
			case PROJECT_STATUS.UNDER_CORRECTION:
				return classNames.projectStatusCorrection;

			default:
				return classNames.projectStatus;
		}
	}, [props.status]);

	const formatStatus = useCallback((status: string) => {
		const index = status.toLowerCase().indexOf('published for');
		if (index === -1) return status;

		return status.toLowerCase().replace('published for', 'awaiting');
	}, []);

	return (
		<div className={concatClassNames([className, props.isActive ? classNames.projectStatusActive : ''])} role='button' onClick={props.onClick}>
			{formatStatus(props.status)}
		</div>
	);
};

export default ProjectStatusButton;
